import React from 'react';
import { COLORS } from '../../theme';

export default function Tabs({ abas, ativa, onMudar, acao }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${COLORS.border}`, marginBottom: 16 }}>
      <div style={{ display: 'flex', gap: 4, overflowX: 'auto' }}>
        {abas.map(aba => {
          const selecionada = aba.chave === ativa;
          return (
            <button
              key={aba.chave}
              onClick={() => onMudar(aba.chave)}
              style={{
                padding: '10px 14px',
                border: 'none',
                borderBottom: selecionada ? `2px solid ${COLORS.primary}` : '2px solid transparent',
                background: 'none',
                color: selecionada ? COLORS.primary : COLORS.textMuted,
                fontWeight: selecionada ? 700 : 500,
                fontSize: 13,
                cursor: 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              {aba.titulo}
            </button>
          );
        })}
      </div>
      {acao && <div style={{ display: 'flex', gap: 10, flexShrink: 0, paddingLeft: 12, paddingBottom: 8 }}>{acao}</div>}
    </div>
  );
}
